import { useContext } from "react";
import UserContext from "shared/context/UserContext";

export const useUser = () => {
    const user = useContext(UserContext);
    return user;
};
